import source from "@/messages/quiz-runner-source.json";
import mandarinQuizRunnerDraft from "@/messages/mandarin-quiz-runner.json";
import type { Locale } from "./locales";

export function quizRunnerCopy(locale: Locale = "en"): typeof source {
  // These catalogues contain only strings; a shallow copy isolates callers on older browsers.
  return { ...(locale === "en" ? source : mandarinQuizRunnerDraft) };
}
export function formatQuizRunner(
  template: string,
  values: Record<string, string | number>
): string {
  return template.replace(/\{([^}]+)\}/g, (_, key: string) => {
    if (!Object.prototype.hasOwnProperty.call(values, key)) {
      throw new Error(`Missing quiz runner value: ${key}`);
    }
    return String(values[key]);
  });
}
